module.exports = __webpack_public_path__ + "static/scale-model-of-the-venice-beach-boardwalk-in-los-angeles-california-cdd5024da6d06147f1435ec4a96b52b8.png";